module.exports = __webpack_public_path__ + "media/images/payment/logo_jcb-3f7c5a66eb93943abd4bb506fcec6f0f.gif";